export type MediaType = 'VIDEO' | 'AUDIO';

export const detectMediaType = (contentType: string): MediaType | null => {
  if (contentType.startsWith('video/')) return 'VIDEO';
  if (contentType.startsWith('audio/')) return 'AUDIO';
  return null;
};
